import { cssSelectorForShops, isHrefShopUrl } from "./helpers"

export async function openExperiment(
  experimentPosition,
  modifications,
  experimentId = null
) {
  const selectedModification = selectModification(
    getUserIdentification(),
    modifications
  )
  placeExperiment(experimentPosition, selectedModification, experimentId)
}

export async function initOneOExperiments() {
  let applicableExperiments = {}

  window.addEventListener("message", handleRecievedExperiments)
  for (let exp of document.querySelectorAll("[data-oneo-exp-id]")) {
    let i = document.createElement("iframe")
    i.style.display = "none"
    i.src = `${window.OneO.shopEnv.checkoutAppBase}/checkouts/experiment/${exp.dataset.oneoExpId}`
    document.body.appendChild(i)
  }

  for (let exp of document.querySelectorAll("[data-oneo-exp]")) {
    let expName = exp.dataset.oneoExp
    let experimentInProperFormat = {
      share: parseInt(exp.dataset.oneoExpShare),
      handle: exp.dataset.oneoExpMod,
      value: {
        domElement: exp
      }
    }
    if (applicableExperiments[expName]) {
      applicableExperiments[expName].push(experimentInProperFormat)
    } else {
      applicableExperiments[expName] = [experimentInProperFormat]
    }
  }

  if (Object.keys(applicableExperiments).length === 0) {
    return
  }

  let userIdentification = await getUserIdentification()

  for (let [handle, modifications] of Object.entries(applicableExperiments)) {
    const selectedModification = selectModification(
      userIdentification,
      modifications
    )
    modifications.forEach((mod) => {
      if (selectedModification.handle !== mod.handle) {
        mod.value.domElement.remove()
      } else {
        const experimentDOM = mod.value.domElement
        experimentDOM.style.display = null

        // Append experiment data to 1o shop url
        if (experimentDOM.href && isHrefShopUrl(experimentDOM.href)) {
          appendExperimentHandlesToUrl(experimentDOM, handle, mod.handle)
        }
        for (let anchor of experimentDOM.querySelectorAll(
          cssSelectorForShops()
        )) {
          appendExperimentHandlesToUrl(anchor, handle, mod.handle)
        }
      }
    })
  }
}

async function handleRecievedExperiments(event) {
  if (
    event.data &&
    event.data.type === "OneoLifecycleEvent" &&
    event.data.event === "availableExperiments"
  ) {
    let userId = await getUserIdentification()
    event.data.data.activeExperiments.forEach((experiment) => {
      const selectedModification = selectModification(
        userId,
        experiment.modifications
      )
      for (let experimentPosition of document.querySelectorAll(
        "[data-oneo-exp-id^='" + experiment.id + "']"
      )) {
        placeExperiment(
          experimentPosition,
          selectedModification,
          experiment.handle
        )
      }
    })
  }
}

function appendExperimentHandlesToUrl(anchor, expHandle, modHandle) {
  let hashParameters = ""
  if (!anchor.href.includes("oneoExp=") && expHandle) {
    hashParameters += `oneoExp=${expHandle}/`
  }
  if (!anchor.href.includes("oneoExpMod=") && modHandle) {
    hashParameters += `oneoExpMod=${modHandle}`
  }
  if (hashParameters !== "") {
    const hashIndex = anchor.href.indexOf("#")
    if (hashIndex !== -1) {
      anchor.href += "/" + hashParameters
    } else {
      anchor.href += "#" + hashParameters
    }
  }
}

async function getUserIdentification() {
  if (window._oneo_user_id_) {
    return window._oneo_user_id_
  }

  try {
    window._oneo_user_id_ = window.localStorage.getItem("oneo_user_id")
  } catch (e) {}

  if (window._oneo_user_id_) {
    return window._oneo_user_id_
  }

  window._oneo_user_id_ = await fetch(
    "https://cloudflare.com/cdn-cgi/trace?format=json"
  )
    .then(async (res) => {
      let textResponse = await res.text()
      return textResponse
        .trim()
        .split("\n")
        .map((e) => e.split("="))
        .find((e) => e[0] === "ip")[1]
    })
    .catch((e) => {
      return Math.random().toString(36).substring(2, 15)
    })

  try {
    window.localStorage.setItem("oneo_user_id", window._oneo_user_id_)
  } catch (e) {}
  return window._oneo_user_id_
}

function placeExperiment(
  experimentPosition,
  selectedModification,
  experimentHandle
) {
  if (!selectedModification.value.htmlElement) {
    return
  }
  let templateElement = document.createElement("template")
  templateElement.innerHTML = selectedModification.value.htmlElement
  templateElement = templateElement.content.firstChild

  // Append experiment data to 1o shop url
  if (templateElement.href && isHrefShopUrl(templateElement.href)) {
    appendExperimentHandlesToUrl(
      templateElement,
      experimentHandle,
      selectedModification.handle
    )
  }
  for (let anchor of templateElement.querySelectorAll(cssSelectorForShops())) {
    appendExperimentHandlesToUrl(
      anchor,
      experimentHandle,
      selectedModification.handle
    )
  }

  experimentPosition.parentNode.replaceChild(
    templateElement,
    experimentPosition
  )
}

// https://stackoverflow.com/questions/7616461/generate-a-hash-from-string-in-javascript
function cyrb53(str, seed = 0) {
  let h1 = 0xdeadbeef ^ seed,
    h2 = 0x41c6ce57 ^ seed
  for (let i = 0, ch; i < str.length; i++) {
    ch = str.charCodeAt(i)
    h1 = Math.imul(h1 ^ ch, 2654435761)
    h2 = Math.imul(h2 ^ ch, 1597334677)
  }
  h1 =
    Math.imul(h1 ^ (h1 >>> 16), 2246822507) ^
    Math.imul(h2 ^ (h2 >>> 13), 3266489909)
  h2 =
    Math.imul(h2 ^ (h2 >>> 16), 2246822507) ^
    Math.imul(h1 ^ (h1 >>> 13), 3266489909)
  return 4294967296 * (2097151 & h2) + (h1 >>> 0)
}

function selectModification(userIdentifier, modifications) {
  if (!userIdentifier || !modifications || modifications == []) {
    return {}
  }
  const hash = cyrb53(userIdentifier)

  const totalShare = modifications.reduce((total, experiment) => {
    return total + experiment.share
  }, 0)
  const chosenShare = (hash % totalShare) + 1
  let shippedShare = 0

  return modifications.find((modification) => {
    if (
      chosenShare > shippedShare &&
      chosenShare <= shippedShare + modification.share
    ) {
      return true
    } else {
      shippedShare += modification.share
      return false
    }
  })
}

function computeExperimentArgs(userIdentifier, experiments) {
  if (!userIdentifier || !experiments || experiments == []) {
    return {}
  }

  const activeExperiments = experiments.filter((experiment) => {
    return (
      (!experiment.startAt || Date.parse(experiment.startAt) < Date.now()) &&
      (!experiment.endAt || Date.parse(experiment.endAt) > Date.now())
    )
  })

  let experimentHandles = []
  let modificationHandles = []
  let checkoutArgsModifiers = activeExperiments.reduce(
    (checkoutArgs, experiment) => {
      const chosenModification = selectModification(
        userIdentifier,
        experiment.modifications
      )
      if (!chosenModification) {
        return checkoutArgs
      }
      experimentHandles.push(experiment.handle)
      modificationHandles.push(
        `${experiment.handle}-${chosenModification.handle}`
      )
      return { ...checkoutArgs, ...JSON.parse(chosenModification.value) }
    },
    {}
  )

  return {
    exps: experimentHandles,
    mods: modificationHandles,
    checkoutArgs: checkoutArgsModifiers
  }
}
